import React, { ReactNode } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

const primaryOkButtonSx = {
  backgroundColor: 'var(--primary-color)',
  '&:hover': { backgroundColor: 'var(--primary-color)', opacity: 0.9 },
} as const;

type Props = {
  open: boolean;
  onOk: () => void;
  title: string;
  titleId: string;
  children: ReactNode;
  /** When true, only the OK button closes the dialog (default). */
  okOnlyDismiss?: boolean;
};

const ClaimFormInfoDialog: React.FC<Props> = ({
  open,
  onOk,
  title,
  titleId,
  children,
  okOnlyDismiss = true,
}) => (
  <Dialog
    open={open}
    maxWidth="sm"
    fullWidth
    aria-labelledby={titleId}
    disableEscapeKeyDown={okOnlyDismiss}
    onClose={
      okOnlyDismiss
        ? (_, reason) => {
            if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
              return;
            }
          }
        : onOk
    }
  >
    <DialogTitle id={titleId}>{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button variant="contained" onClick={onOk} autoFocus sx={primaryOkButtonSx}>
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

export default ClaimFormInfoDialog;
